<template>
  <el-row style=" position: unset; margin-bottom: 30px;">
    <div>
      <div class="step-special-offer hide-line">
        <a @click="showSpecialOfferContainer('general')">
          <el-button :type="isStepActive.general" circle>
            <font-awesome-icon icon="file-alt" />
          </el-button>
          <div>{{$t('general')}}</div>
        </a>
      </div>
      <div class="step-special-offer" :class="isStepActive.agent">
        <a @click="showSpecialOfferContainer('agent')">
          <el-button :type="isStepActive.agent" circle>
            <font-awesome-icon icon="user-alt" />
          </el-button>
          <div>{{$t('agent')}}</div>
        </a>
      </div>
      <div class="step-special-offer" :class="isStepActive.promotion">
        <a @click="showSpecialOfferContainer('promotion')">
          <el-button :type="isStepActive.promotion" circle>
            <font-awesome-icon icon="star" />
          </el-button>
          <div>{{$t('promotion')}}</div>
        </a>
      </div>
    </div>
    <el-button
      v-if="currentTab !== 'general'"
      type="primary"
      class="prev-tab tab-action"
      @click="onClickChangeTabSpecialOffer(PREV)">
      <i class="el-icon-arrow-left"></i>
    </el-button>
    <el-button
      v-if="currentTab !== 'promotion'"
      type="primary"
      class="next-tab tab-action"
      @click="onClickChangeTabSpecialOffer(NEXT)">
      <i class="el-icon-arrow-right"></i>
    </el-button>
  </el-row>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import i18nMessages from '@/translations/SpecialOffer/components/SpecialOfferMenuComponent.i18n'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faFileAlt, faUserAlt, faStar } from '@fortawesome/free-solid-svg-icons'

const TAB_KEY_LIST = ['general', 'agent', 'promotion']
const PREV = -1
const NEXT = 1

library.add(faFileAlt, faUserAlt, faStar)

export default {
  name: 'SpecialOfferMenuComponent',
  i18n: { messages: i18nMessages },
  components: { FontAwesomeIcon },
  created: function () {},
  data () {
    return {
      PREV,
      NEXT,
      isStepActive: {
        general: 'primary',
        agent: '',
        promotion: ''
      },
      isShowContainer: {
        general: true,
        agent: false,
        promotion: false
      },
      currentTab: TAB_KEY_LIST[0]
    }
  },
  methods: {
    showSpecialOfferContainer: function (containerName) {
      for (let name in this.isShowContainer) {
        this.isShowContainer[name] = false
        this.isStepActive[name] = ''
      }

      this.isShowContainer[containerName] = true
      this.isStepActive[containerName] = 'primary'
      this.currentTab = containerName

      this.$emit('onClickSpecialOfferMenu', this.isShowContainer)
    },
    onClickChangeTabSpecialOffer: function (step) {
      const currentTabIndex = TAB_KEY_LIST.indexOf(this.currentTab)
      const tabName = TAB_KEY_LIST[currentTabIndex + step]
      this.showSpecialOfferContainer(tabName)
    }
  }
}
</script>

<style scoped>
  .step-special-offer {
    list-style: none;
    float: left;
    text-align: center;
    width: calc(100% / 3);
    font-weight: bold;
    font-size: 15px;
    position: relative;
  }
  .step-special-offer > a > div {
    margin-top: 5px;
    cursor: pointer;
  }

  .tab-action {
    position: relative;
    border-radius: 0;
    width: 40px;
    height: 60px;
    top: -70px;
  }
  .next-tab {
    right: 0px;
    top: calc(97px + (50% - 78.5px));
    position: absolute;
    z-index: 1;
  }
  .next-tab i {
    font-size: 30px;
    right: 15px;
    position: relative;
  }
  .prev-tab {
    left: 0px;
    top: calc(97px + (50% - 78.5px));
    position: absolute;
    z-index: 1;
  }
  .prev-tab i {
    font-size: 30px;
    left: -15px;
    position: relative;
  }
  .el-button.is-circle {
    width: 42px;
    height: 42px;
  }
  .step-special-offer::before {
    content: '';
    border-bottom: 4px solid #DBDBDB;
    width: calc(100% - 42px);
    display: block;
    position: absolute;
    margin-left: 1px;
    margin-top: -2px;
    top: 21px;
    right: calc(50% + 21px);
  }

  .step-special-offer.primary::before {
    border-bottom: 4px solid #409EFF;
  }

  .step-special-offer.hide-line::before {
    display: none !important;
  }
</style>
